import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'upsellDefaultTitle',
  initialState: '',
  reducers: {
    setUpsellDefaultTitle(undefined, action: PayloadAction<string>) {
      return action.payload;
    },
  },
});

export const { setUpsellDefaultTitle } = slice.actions;
export default slice.reducer;
